export default __webpack_public_path__ + "static/2-3be86eabec39bc167e1c9acbb139c28c.png";